// Responsive header
$(document).ready(function () {
  $('.toggler-btn').click(function () {
    $('.body-overlay').addClass('show');
    $('body').addClass('overflow-hidden');
  });

  $('.tabs-close-btn').click(function () {
    $('.product').removeClass('tabs-open');
     $('body').removeClass('overflow-hidden');
  });
});


// Owl Carousel slider JS
$(document).ready(function () {
  // Hero Slider
  $('.hero-slider').owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 8000,
    autoplayHoverPause: true,
    nav: true,
    dots: true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    navText: [
      '<i class="fa-solid fa-chevron-left"></i>',
      '<i class="fa-solid fa-chevron-right"></i>'
    ]
  });

  // Product Slider
  $('.product-slider').owlCarousel({
    items: 4,
    loop: true,
    margin: 24,
    responsive: {
      0: {
        items: 1,
        nav: false
      },
      600: {
        items: 2,
        nav: true
      },
      1000: {
        items: 4,
        margin: 24,
        nav: true
      }
    },
    navText: [
      '<i class="fa-solid fa-chevron-left"></i>',
      '<i class="fa-solid fa-chevron-right"></i>'
    ]
  });

  // Product Description Slider
  $('.product-description-slider').owlCarousel({
    loop: false,
    margin: 24,
    nav: false,
    responsive: {
      0: { items: 1, dots: true },
      600: { items: 2, dots: true },
      1000: { items: 4, dots: false }
    }
  });

  // Trustpol Slider
  $('.trustpol-slider').owlCarousel({
    loop: true,
    margin: 24,
    nav: true,
    dots: false,
    responsive: {
      0: { items: 1 },
      776: { items: 2 },
      992: { items: 3 },
      1200: { items: 4 }
    },
    navText: [
      '<i class="fa-solid fa-chevron-left"></i>',
      '<i class="fa-solid fa-chevron-right"></i>'
    ]
  });
});

// $(document).ready(function () {
//   function initializeCarousel() {
//     return $('.product-slider.owl-carousel').owlCarousel({
//       items: 4,
//       loop: true,
//       margin: 24,
//       responsive: {
//         0: {
//           items: 1,
//           nav: false
//         },
//         600: {
//           items: 2,
//           nav: true
//         },
//         1000: {
//           items: 4,
//           margin: 24,
//           nav: true
//         }
//       },
//       navText: [
//         '<i class="fa-solid fa-chevron-left"></i>',
//         '<i class="fa-solid fa-chevron-right"></i>'
//       ]
//     });
//   }

  // Initialize the carousel for the active tab on page load
  // let productSlider = initializeCarousel();

  // Tab click event
//   $('.tab').click(function () {
//     const tabId = $(this).data('tab');

//     // Toggle active class for tabs and tab contents
//     $('.tab').removeClass('active');
//     $(this).addClass('active');
//     $('.tab-content').removeClass('active');
//     $('#tab-' + tabId + '-content').addClass('active');

//     // Destroy the current carousel instance
//     productSlider.trigger('destroy.owl.carousel');

//     // Reinitialize the carousel for the newly active tab
//     productSlider = initializeCarousel();
//   });
// });



// // Product click tabs
// // $(document).ready(function () {
// //   $('.tab').click(function () {
// //     var tabId = $(this).data('tab');
// //     $('.tab').removeClass('active');
// //     $(this).addClass('active');
// //     $('.tab-content').removeClass('active');
// //     $('#tab-' + tabId + '-content').addClass('active');

// //     // Refresh Owl Carousel in the active tab
// //     if ($('#tab-' + tabId + '-content').find('.owl-carousel').length) {
// //       owl.trigger('refresh.owl.carousel');
// //     }
// //   });
// });

// $(document).ready(function () {
//   $('.tab').click(function (e) {
//     var href = $(this).attr('href');
//     if (href && href.startsWith('#')) { // Only prevent default if it's an internal link
//       e.preventDefault();
//     }
//     $('.tab').removeClass('active'); // Remove active class from all tabs/links
//     $(this).addClass('active'); // Add active class to the clicked link
//   });
// });

jQuery(function($) {

  var path = window.location.href; 

  // because the 'href' property of the DOM element is the absolute path

  $('.tabs-container a.collection-nav').each(function() {

    if (this.href === path) {

      $(this).addClass('active');

    }

  });

});

// Product page filter
$(document).ready(function () {
  $('.selected').click(function () {
    $(this).parent().toggleClass('open');
    $(this).siblings('.custom-options').css('max-height', $(this).parent().hasClass('open') ? '200px' : '0');
  });

  $('.custom-options div').click(function () {
    $(this).closest('.custom-select').find('.selected span').text($(this).text());
    $(this).closest('.custom-select').removeClass('open').find('.custom-options').css('max-height', '0');
  });

  $(document).click(function (e) {
    if (!$(e.target).closest('.custom-select').length) {
      $('.custom-select').removeClass('open').find('.custom-options').css('max-height', '0');
    }
  });
});


// More filter
$(document).ready(function () {
  $('.accordion-heading').click(function () {
    var $currentContent = $(this).next('.accordion-content');
    var $accordion = $(this).closest('.accordion');

    if ($currentContent.is(':visible')) {
      $currentContent.slideUp();
      $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
    } else {
      $accordion.find('.accordion-content').slideUp();
      $accordion.find('.accordion-heading i').addClass('fa-chevron-down').removeClass('fa-chevron-up');
      $currentContent.slideDown();
      $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
    }
  });

  

  $('#priceRange').on('input', function () {
    $('#priceValue').text(this.value);
  });

  $('#priceValue').text($('#priceRange').val());
});

// More filter open
$(document).ready(function () {
  $('.more-filt').click(function () {
    $('.more-filt-ctn, .body-overlay').addClass('show');
    $('body').addClass('overflow-hidden');
  });

  $('.filt-cancel').click(function () {
    $('.more-filt-ctn, .body-overlay').removeClass('show');
    $('body').removeClass('overflow-hidden');
  });

  $('.body-overlay').click(function () {
    $('.more-filt-ctn, .body-overlay').removeClass('show');
    $('body').removeClass('overflow-hidden');
  });
});

// Quantity increase
$(document).ready(function () {
  $('#increase').click(function () {
    let quantity = parseInt($('#quantity').val());
    $('#quantity').val(quantity + 1);
  });

  $('#decrease').click(function () {
    let quantity = parseInt($('#quantity').val());
    if (quantity > 1) {
      $('#quantity').val(quantity - 1);
    }
  });
});

// View filter
$(document).ready(function () {
  $('.one-view').click(function () {
    $('.grid-container').addClass('active');
  });

  $('.four-view').click(function () {
    $('.grid-container').removeClass('active');
  });
});

// Price slider
$(document).ready(function () {
  slideOne();
  slideTwo();

  $('#slider-1').on('input', function () {
    slideOne();
  });

  $('#slider-2').on('input', function () {
    slideTwo();
  });

  function slideOne() {
    var sliderOne = $('#slider-1');
    var sliderTwo = $('#slider-2');
    if (parseInt(sliderTwo.val()) - parseInt(sliderOne.val()) <= 0) {
      sliderOne.val(parseInt(sliderTwo.val()));
    }
    $('#range1').text(sliderOne.val());
    fillColor();
  }

  function slideTwo() {
    var sliderOne = $('#slider-1');
    var sliderTwo = $('#slider-2');
    if (parseInt(sliderTwo.val()) - parseInt(sliderOne.val()) <= 0) {
      sliderTwo.val(parseInt(sliderOne.val()));
    }
    $('#range2').text(sliderTwo.val());
    fillColor();
  }

  function fillColor() {
    var sliderOne = $('#slider-1').val();
    var sliderTwo = $('#slider-2').val();
    var sliderMaxValue = $('#slider-1').attr('max');
    var percent1 = (sliderOne / sliderMaxValue) * 100;
    var percent2 = (sliderTwo / sliderMaxValue) * 100;
    $('.slider-track').css('background', 'linear-gradient(to right, #dadae5 ' + percent1 + '% , #000 ' + percent1 + '% , #000 ' + percent2 + '%, #dadae5 ' + percent2 + '%)');
  }
});

// Sticky header
$(document).ready(function () {
  var lastScrollTop = 0;
  var header = $('.bottom-header');

  $(window).scroll(function () {
    var scrollTop = $(this).scrollTop();

    if (scrollTop > lastScrollTop) {
      header.addClass('sticky');
    } else {
      header.removeClass('sticky');
    }

    lastScrollTop = scrollTop;
  });
});

// Loader JS
// window.onload = function() {
//   $('.loader').addClass('show');
//   setTimeout(function() {
//       $('.loader').removeClass('show'); 
//       $('.content').fadeIn(); 
//   }, 3000); 
// };

// sticky-header-js-start
    $(window).scroll(function(){
        if ($(this).scrollTop() > 90) {
            $('.header').addClass('sticky-header');
        } else {
            $('.header').removeClass('sticky-header');
        }
    });
// sticky-header-js-end

$(document).ready(function () {
  // Initialize the main product slider

  // Syncing main product image with thumbnail clicks
  var bigimage = $("#main-product");
  var thumbs = $("#thumbs");
  var syncedSecondary = true;

  bigimage.owlCarousel({
    items: 1,
    slideSpeed: 2000,
    nav: true,
    autoplay: false,
    dots: false,
    loop: true,
    responsiveRefreshRate: 200,
    margin: 15
  }).on("changed.owl.carousel", syncPosition);

  thumbs.on("initialized.owl.carousel", function () {
    thumbs.find(".owl-item").eq(0).addClass("current");
  }).owlCarousel({
    items: 4,
    dots: false,
    nav: true,
    margin: 18,
    smartSpeed: 2000,
    slideSpeed: 2000,
    slideBy: 4,
    responsiveRefreshRate: 100,
    navText: [
      '<i class="fa-solid fa-chevron-left"></i>',
      '<i class="fa-solid fa-chevron-right"></i>'
    ]
  }).on("changed.owl.carousel", syncPosition2);

  function syncPosition(el) {
    var count = el.item.count - 1;
    var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }

    thumbs.find(".owl-item").removeClass("current").eq(current).addClass("current");

    var onscreen = thumbs.find(".owl-item.active").length - 1;
    var start = thumbs.find(".owl-item.active").first().index();
    var end = thumbs.find(".owl-item.active").last().index();

    if (current > end) {
      thumbs.data("owl.carousel").to(current, 100, true);
    }
    if (current < start) {
      thumbs.data("owl.carousel").to(current - onscreen, 100, true);
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      var number = el.item.index;
      bigimage.data("owl.carousel").to(number, 100, true);
    }
  }

  thumbs.on("click", ".owl-item", function (e) {
    e.preventDefault();
    var number = $(this).index();
    bigimage.data("owl.carousel").to(number, 300, true);
  });
});

// $(window).on('load', function () {
//   $('#main-product').owlCarousel({
//       items: 1,
//       nav: true,
//       dots: true,
//       autoplay: true,
//       autoplayTimeout: 3000,
//       loop: true
//   });

//   $('#thumbs').owlCarousel({
//       items: 4,
//       nav: true,
//       dots: false,
//       margin: 10,
//       loop: true
//   });

//   // Rest of the code...
// });
document.addEventListener('DOMContentLoaded', () => {
    const addToCartButton = document.querySelector('.buy-btn');
    const variantSelect = document.getElementById('variant-select');
    
    // Check if the product has variants (Check if variantSelect exists and has options)
    const hasVariants = variantSelect && variantSelect.options.length > 1;

    // Add event listener for the Add to Cart button
    addToCartButton.addEventListener('click', event => {
        event.preventDefault(); // Prevent form submission

        // If the product is simple (no variants), we directly add the product to cart
        if (!hasVariants) {
            // In this case, the product is simple, no variant is selected
            const quantity = document.getElementById('quantity') ? document.getElementById('quantity').value : 1; // Default to 1 if quantity input is missing
            
            // Simple product has no variant, so we need to add it directly to cart
            const simpleProductId = document.querySelector('input[name="id"]').value; // Get the simple product ID from the hidden input field

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: simpleProductId, quantity: parseInt(quantity) })
            })
                .then(res => res.json())
                .then(data => {
                    console.log('Simple product added to cart:', data);
                    updateCart();
                    window.location.href = '/cart'; // Redirect to cart after adding
                })
                .catch(err => console.error('Error adding simple product to cart:', err));

            return; // Exit the function since we're adding a simple product
        }

        // If the product has variants, ensure a variant is selected
        if (variantSelect) {
            const selectedVariantId = variantSelect.value; // Selected variant ID
            const quantity = document.getElementById('quantity') ? document.getElementById('quantity').value : 1; // Default to 1 if quantity input is missing

            if (selectedVariantId) {
                // Add the selected variant to Cart via AJAX
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: selectedVariantId, quantity: parseInt(quantity) })
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log('Variant added to cart:', data);
                        updateCart();
                        window.location.href = '/cart'; // Redirect to cart after adding
                    })
                    .catch(err => console.error('Error adding variant to cart:', err));
            } else {
                alert('Please select a variant.');
            }
        }
    });

    // Function to Update Cart
    function updateCart() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                console.log('Cart:', cart);
                renderCart(cart); // Update cart UI
            })
            .catch(err => console.error('Error updating cart:', err));
    }

    // Function to Render Cart
    function renderCart(cart) {
        const cartContainer = document.querySelector('.cart-items');
        if (!cartContainer) return;

        cartContainer.innerHTML = ''; // Clear old cart items

        cart.items.forEach(item => {
            const cartItemHTML = `
                <div class="cart-item">
                    <img src="${item.image}" alt="${item.product_title}" />
                    <div>
                        <h4>${item.product_title}</h4>
                        <p>Variant: ${item.variant_title}</p>
                        <p>Quantity: ${item.quantity}</p>
                        <p>Price: ${Shopify.formatMoney(item.line_price)}</p>
                    </div>
                </div>
            `;
            cartContainer.innerHTML += cartItemHTML;
        });

        const cartTotal = document.querySelector('.cart-total');
        if (cartTotal) {
            cartTotal.textContent = `Total: ${Shopify.formatMoney(cart.total_price)}`;
        }
    }
});





